import { PropsWithChildren } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { SeoTagsProps } from './types'

const SeoTags = ({ title, children }: PropsWithChildren<SeoTagsProps>) => {
  return (
    <Helmet>
      <title>{title} | My Bolt</title>
      {children}
    </Helmet>
  )
}

export default SeoTags
